export default __webpack_public_path__ + "static/media/bank-bg.514ee8a2.png";